import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import { getCSRFToken, ROOT_URL_V2 } from '../../../config';
import { ErrorMessage } from '../../common';
import { getErrorMessages } from '../../../utils';
import LoadingSpinner from '../../common/LoadingSpinner';
import { TPageNotification } from '../../../types';


type TModalCancelSeriesProps = {
    notification: TPageNotification;
    reloadData: () => void;
    handleClose: (modalName: string) => void;
    isOpen: boolean;
    seriesId: number;
}

export function ModalCancelSeries({
    notification,
    reloadData,
    handleClose,
    isOpen,
    seriesId,
}: TModalCancelSeriesProps) {

    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [freelancers, setFreelancers] = useState([]);
    const freelancersNames = freelancers.map(
        freelancer => ([<p key={freelancer.id}>{freelancer.full_name}</p>])
    );
    const [isSilent, setIsSilent] = useState(false);

    useEffect(() => {

        async function getOptions() {
            if (isOpen) {
                try {
                    const response = await axios({
                        method: 'GET',
                        url: `${ROOT_URL_V2}series/${seriesId}/freelancers/`,
                        headers: {
                            'X-CSRFToken': getCSRFToken(),
                        },
                    });
                    setFreelancers(response.data.content);
                } catch (err) {
                    setError(getErrorMessages(err));
                }
            }
        } getOptions();
    }, [isOpen, seriesId]);


    const handleConfirm = (): void => {
        setIsLoading(true);

        axios({
            method: 'patch',
            url: `${ROOT_URL_V2}series/${seriesId}/cancel_series/`,
            data: {
                'status': 'CA',
                'is_silent': isSilent,
            },
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        }).then(() => {
            setIsLoading(false);
            handleClose('CancelSeries');

            notification.success(
                'Success',
                `Ongoing job ${seriesId} has been successfully cancelled.`
            );

            reloadData();
        }).catch(err => {
            setIsLoading(false);
            setError(getErrorMessages(err));
        });

    };


    return (
        <Modal
            className="cancel-worker-modal"
            isOpen={isOpen}
            onRequestClose={() => handleClose('CancelSeries')}
            contentLabel="Confirm shift"
            ariaHideApp={false}
        >
            <p className="modal-title">Cancel ongoing job</p>
            <div className="cancel-worker-body">
                {freelancersNames.length !== 0 ? (
                    <>
                        <p>Are you sure you want to cancel the ongoing job <b>{seriesId}</b></p>
                        <p> and remove all future bookings for: </p>
                        <b>{freelancersNames}</b>
                    </>

                ) : <>
                        <p>Are you sure you want to cancel the ongoing job <b>{seriesId}</b> ?</p>
                        <p> (No workers booked for this job.)</p>
                    </>
                }
                <div className="margin-top-20">
                    <label className="cancel-worker-checkbox">
                        <input
                            className="checkbox-purple"
                            type="checkbox"
                            checked={isSilent}
                            onChange={event => {
                                setIsSilent(event.target.checked);
                            }}
                        />
                        <span>Cancel silently</span>
                    </label>
                </div>
            </div>

            <button
                className="continue btn--round-big"
                onClick={handleConfirm}
                type="button"
                disabled={isLoading}
            >
                {isLoading ? (
                    <LoadingSpinner
                        className="cancel-worker-spinner"
                        backgroundColor="white"
                    />
                ) : (
                    'CONFIRM'
                )}
            </button>
            {!isLoading && (
                <button className="back" onClick={() => handleClose('CancelSeries')} type="button">
                    CANCEL
                </button>
            )}
            {!!error && <ErrorMessage message={error} />}
        </Modal>
    );
}
